import { makeAutoObservable } from 'mobx';
import KinnectAxiosApi from '../utils/KinnectAxiosApi';
import { RequestStatus } from '../../../shared/enums/RequestStatus';

export interface PasswordValidation {
  isAtLeastFiveChars: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasDigit: boolean;
}

class KinnectPasswordResetPageStore {
  private _newPassword!: string;
  private _newPasswordConfirmation!: string;

  passwordValidation: PasswordValidation = {
    isAtLeastFiveChars: false,
    hasUppercase: false,
    hasLowercase: false,
    hasDigit: false,
  };

  errors: string[];
  requestStatus: RequestStatus;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
    this.errors = [];
    this.requestStatus = RequestStatus.INITIAL;
  }

  setNewPassword(newPassword: string) {
    this._newPassword = newPassword;
  }

  setNewPasswordConfirmation(newPasswordConfirmation: string) {
    this._newPasswordConfirmation = newPasswordConfirmation;
  }

  validatePassword(password: string): void {
    const hasUppercase = /[A-Z]/;
    const hasLowercase = /[a-z]/;
    const hasDigit = /\d/;
    const isAtLeastFiveChars = /^.{5,}$/;

    this.passwordValidation = {
      isAtLeastFiveChars: isAtLeastFiveChars.test(password),
      hasUppercase: hasUppercase.test(password),
      hasLowercase: hasLowercase.test(password),
      hasDigit: hasDigit.test(password),
    };
  }

  async resetPassword(encodedToken: string): Promise<void> {
    this.errors = [];

    if (Object.values(this.passwordValidation).includes(false)) {
      this.errors.push(
        'Please verify that your password meets all the requirements.'
      );
    }

    if (this._newPassword !== this._newPasswordConfirmation) {
      this.errors.push('Passwords do no match, please try again.');
    }

    if (!this.errors.length) {
      try {
        await KinnectAxiosApi.resetPassword(this._newPassword, encodedToken);
        this.requestStatus = RequestStatus.SUCCESS;
      } catch {
        this.requestStatus = RequestStatus.FAILURE;
      }
    }
  }
}

export default KinnectPasswordResetPageStore;
